<template>
  <div class="outer">
    <slot name="outer"/>
    <div class="inner" :style="{ minWidth: `${100 / scale}%`, transform: `scale(${scale})` }">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    zoom: Number,
  },
  data() {
    return {
      scale: 1 / this.zoom
    }
  },
  mounted() {
    this.$watch("zoom", () => {
      if (!this.update) {
        this.update = () => {
          const scale = 1 / this.zoom

          let factor = this.scale / scale
          if (factor < 1) factor = 1 / factor

          if (factor < 1.005) {
            this.scale = scale
            cancelAnimationFrame(this.update)
            this.update = null
          } else {
            this.scale = (scale + this.scale * 2) / 3
            requestAnimationFrame(this.update)
          }
        }
        requestAnimationFrame(this.update)
      }
    })
  }
}
</script>

<style scoped>
.outer {
  position: relative;
  /* overflow: auto; */
}

.inner {
  transform-origin: 0 0;
  position: absolute;
  overflow: hidden;
}
</style>
